module.exports = __webpack_public_path__ + "416c1849.svg";